<template>
  <div class="container">
    <CustomHeader :title="'共享文件'" :iconColor="'#4475e2'">
      <div class="actions">
        <div class="breadcrumb">
          <div class="breadcrumb-item" @click="reset">
            <span class="breadcrumb-label">全部文件</span>
          </div>
          <div class="breadcrumb-item" @click="navigation(item)" v-for="item in menus" :key="item.id">
            <span class="el-icon-arrow-right"></span>
            <span class="breadcrumb-label">{{ item.label }}</span>
          </div>
        </div>
        <div class="play">
          <el-input size="small" v-model="keyWork" clearable placeholder="请输入名称" />
          <el-button type="primary" size="mini" @click="refresh" plain>搜索</el-button>
          <el-button type="primary" size="mini" @click="showEditAddDialog('新增文件夹')" icon="el-icon-circle-plus-outline" plain
            >新增文件夹</el-button
          >
          <el-upload
            class="upload-demo"
            v-if="parentId"
            :action="uploadUrl"
            :headers="uploadHead"
            :data="{ type: 225 }"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :before-upload="beforeUpload">
            <el-button size="mini" type="primary" class="primary" icon="el-icon-upload2" plain>点击上传文件</el-button>
          </el-upload>

          <el-button
            type="primary"
            size="mini"
            :disabled="move"
            plain
            @click="
              isDownload = !isDownload
              checkedType = '0'
            "
            >{{ isDownload ? '取消合并' : '多选合并' }}</el-button
          >
          <el-button
            type="primary"
            size="mini"
            :disabled="isDownload"
            plain
            @click="
              move = !move
              checkedType = '1'
            "
            >{{ move ? '取消移动' : '移动文件夹' }}</el-button
          >
          <template v-if="isDownload || move">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <el-tooltip
              class="item"
              effect="dark"
              :content="isDownload ? '选中文件后, 可以合并为一个文件' : '选中文件后, 可以移动到其他文件夹中'"
              placement="top">
              <el-button type="primary" plain size="mini" @click="handleDownloads">{{ isDownload ? '合并' : '移动' }}</el-button>
            </el-tooltip>
          </template>
        </div>
      </div>
    </CustomHeader>
    <div class="content" @contextmenu.prevent>
      <!-- 文件列表 -->
      <FileList
        :list="dirList"
        :checkeds="checkeds"
        :isDownload="isDownload || move"
        @download="handleDownload"
        @checkchange="handleCheckChange"
        @open="handleOpen"
        @update="handleUpdate"
        @delete="handleDelete" />
    </div>

    <EditAddDialog
      :dialog.sync="dialogVisible"
      :title="title"
      :id="dirId"
      :info="info"
      :parentId="parentId"
      @success="handleSuccess"
      @close="handleAddEditClose" />

    <MergeDialog :dialog.sync="mergeDialog" @confim="handleConfim" />

    <MoveDialog :dialog.sync="moveDialog" @confim="handleMoveconfim" />

    <div class="hint">提示: 拖到文件夹或文件可以进行排序</div>
  </div>
</template>

<script>
import base from '@/untils/base'
import util from '@/untils/util'
import CustomHeader from '@/components/customHeader.vue'
import FileList from './components/FileList.vue'
import EditAddDialog from './components/EditAddDialog.vue'
import MergeDialog from './components/mergeDialog.vue'
import MoveDialog from './components/MoveDialog.vue'
import {
  getFilesSelectFolder,
  getFilesSelectDocumentNew,
  deleteFilesDeleteFiles,
  postFilesAddFiles,
  postFilesDownloadZip,
  postFilesMergeFolderOrFile,
  postFilesMoveFolderOrFile,
} from './api.js'

export default {
  data() {
    return {
      moveDialog: false,
      checkedType: '',
      move: false,
      mergeDialog: false,
      isDownload: false,
      isIndeterminate: false,
      checkAll: false,
      keyWork: '',
      uploadUrl: base.url + '/upload/uploadPhoto',
      uploadHead: {
        //上传接口header
        accessToken: util.session.get('token'),
      },
      projectId: util.session.get('groupId'),
      title: '新增文件夹',
      dialogVisible: false,
      dirId: '',
      parentId: '',
      parentIdPassword: '',
      dirList: [],
      menus: [],
      loading: null,
      checkeds: [],
      listId: [],
      downloadId: [],
    }
  },
  components: {
    CustomHeader,
    FileList,
    EditAddDialog,
    MergeDialog,
    MoveDialog,
  },
  async created() {
    this.dirList = await this.getDirList()
  },
  mounted() {},
  methods: {
    async handleMoveconfim(id) {
      try {
        const params = {
          projectId: this.projectId,
          parentId: id,
          ids: this.downloadId.join(','),
        }

        const { data: res } = await postFilesMoveFolderOrFile(params)

        if (res.code === 200) {
          this.$message.success('移动成功')
          this.refresh()
          this.moveDialog = false
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    async handleConfim(name) {
      try {
        const params = {
          filesType: '1',
          filesName: name,
          groupId: this.projectId,
          createBy: util.session.get('user').id,
          userType: util.session.get('roleId'),
          parentId: this.parentId || '0',
          ids: this.downloadId.join(','),
        }
        const { data: res } = await postFilesMergeFolderOrFile(params)
        if (res.code === 200) {
          this.$message.success('合并成功')
          this.refresh()
          this.mergeDialog = false
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    // 右键文件夹下载
    async handleDownload(item) {
      this.downloadUtil(item.id)
    },
    async downloadUtil(ids) {
      try {
        const { data: res } = await postFilesDownloadZip({ ids })
        let blob = new Blob([res], { type: 'application/zip' })
        let url = URL.createObjectURL(blob)
        const link = document.createElement('a') // 创建a标签
        link.href = url
        link.download = new Date().toLocaleTimeString() // 重命名文件
        link.click()
        URL.revokeObjectURL(url) // 释放内存
      } catch (error) {
        this.$message.error(error)
      }
    },
    // 刷新页面
    async refresh() {
      if (!this.parentId) {
        this.dirList = await this.getDirList()
      } else {
        this.getFilesList(this.parentId, this.parentIdPassword)
      }
    },
    // 多选下载
    handleDownloads() {
      if (this.downloadId.length) {
        if (this.checkedType == '1') {
          this.moveDialog = true
        } else {
          this.mergeDialog = true
        }
      } else {
        this.$message.info('请选择需要合并的文件!')
      }
    },
    // 选中文件夹事件
    handleCheckChange(val) {
      this.downloadId = val
      this.checkAll = this.listId.length === val.length
      this.isIndeterminate = val.length > 0 && val.length < this.listId.length
    },
    // 选中改变事件
    handleCheckAllChange(val) {
      this.checkeds = val ? this.listId : []
      this.downloadId = val ? this.listId : []
      this.isIndeterminate = false
    },
    // 显示添加或修改对话框
    showEditAddDialog(type, info = null) {
      this.title = type

      if (info) {
        this.info = info
        this.dirId = info.id
      }

      this.dialogVisible = true
    },
    // 获取文件夹
    async getDirList(id = undefined) {
      try {
        let list = []
        const params = {
          groupId: this.projectId,
          parentId: id || '0',
          filesType: '1',
          filesName: this.keyWork,
          userType: util.session.get('roleId'),
        }

        const { data: res } = await getFilesSelectFolder(params)

        if (res.code == 200) {
          list = res.data.Files.sort((a, b) => a.sort - b.sort)
        }
        return list
      } catch (error) {
        this.$message.error(error)
      }
    },
    // 获取文件
    async getFilesList(id, password = null) {
      const arr1 = await this.getDirList(id)

      try {
        const params = {
          id: id,
          pageNum: 1,
          pageSize: 9999,
          password: password || undefined,
          name: this.keyWork,
        }

        const { data: res } = await getFilesSelectDocumentNew(params)

        if (res.code == 200) {
          const result = [...arr1, ...res.data.Files.data]
          this.dirList = result.sort((a, b) => a.sort - b.sort)
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    // 添加文件夹成功
    handleSuccess() {
      this.dirId = null
      this.refresh()
    },
    // 关闭添加或修改对话框触发
    handleAddEditClose() {
      this.dirId = null
      this.info = null
    },
    // 打开文件夹
    handleOpen(item) {
      this.parentId = item.id
      this.parentIdPassword = item.oldPassword
      this.menus.push({ label: item.filesName, id: item.id, password: item.oldPassword })
      this.getFilesList(item.id, item.oldPassword)
    },
    // 重置为主文件夹
    async reset() {
      this.parentId = null
      this.parentIdPassword = null
      this.menus = []
      this.dirList = await this.getDirList()
    },
    // 文件夹导航
    navigation(link) {
      this.parentId = link.id
      this.parentIdPassword = link.password
      const index = this.menus.findIndex((item) => item.id === link.id)
      this.menus = this.menus.filter((_, i) => i <= index)
      this.getFilesList(link.id, link.password)
    },
    // 点击编辑按钮触发
    handleUpdate(item) {
      this.showEditAddDialog('编辑文件夹', item)
    },
    // 删除文件夹或文件
    handleDelete(item) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const params = {
            id: item.id,
            password: item.oldPassword,
          }
          const { data: res } = await deleteFilesDeleteFiles(params)
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.refresh()
          }
        })
        .catch(() => {})
    },
    // 上传成功
    uploadSuccess(res, file, fileList) {
      if (res.code == 200) {
        const name = file.name
        const url = res.data.saveUrls

        this.createFile(name, url)
      } else {
        this.loading && this.loading.close()
        this.$message.error(res.msg)
      }
    },
    // 导入文件
    async createFile(name, url) {
      try {
        const params = {
          filesType: '2',
          filesName: name,
          filesAddress: url,
          groupId: this.projectId,
          createBy: util.session.get('user').id,
          userType: util.session.get('roleId'),
          parentId: this.parentId || '0',
        }

        const { data: res } = await postFilesAddFiles(params)

        if (res.code == 200) {
          this.refresh()
          this.loading && this.loading.close()
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    // 上传文件时触发
    beforeUpload() {
      this.loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
  },
  watch: {
    dirList(newVal) {
      if (newVal?.length) {
        this.listId = newVal.map((item) => item.id)
      } else {
        this.listId = []
      }

      this.isDownload = false
      this.move = false
    },
    isDownload() {
      this.checkAll = false
      this.checkeds = []
      this.isIndeterminate = false
      this.downloadId = []
    },
    move() {
      this.checkAll = false
      this.checkeds = []
      this.isIndeterminate = false
      this.downloadId = []
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;

  .content {
    position: relative;
    flex: 1;
    overflow-y: auto;
    padding: 0 0.4vw;
  }
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: 0 0.4vw;
}

.breadcrumb {
  display: flex;
  align-items: center;

  .breadcrumb-item {
    .breadcrumb-label {
      cursor: pointer;
      padding: 0.2vh 0.4vw;
      transition: all 0.4s;
      border-radius: 4px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.08);
        color: #000;
      }
    }
  }
}

.play {
  display: flex;
  align-items: center;

  & > button {
    margin: 0 0.2vw;
  }
  & > label {
    margin: 0 0.2vw;
  }
  & > div {
    margin: 0 0.2vw;
  }
}

.hint {
  position: fixed;
  left: 50%;
  bottom: 2%;
  transform: translateX(-50%);
}
</style>
